export default function getResource(label, vars = []) {
    const resources = {
        viewAll: 'Voir tout',
        title: 'Activité liée aux points',
        noPoints: 'Votre activité liée aux points s’affichera ici.',
        doNotSeePoints: 'Vous ne voyez pas encore vos points? Votre activité sera mise à jour dans les 24 heures.',
        errorLoadingPoints: 'Nous ne pouvons pas charger votre activité liée aux points pour le moment. Veuillez réessayer plus tard.'
    };
    return resources[label];
}
